import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import VideosLanding from "../views/VideosLanding"

export default function Videos() {

  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <VideosLanding />
    }

    return null;
  }

  useEffect(() => {
    init();
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem])

  return view;
}
